import {Flex, Heading} from '@chakra-ui/react'
import react from 'react';

type PropType ={
    label:string;
    button_array?: any[];
}
const TopDisplay = ({label,button_array}:PropType) => {

  return (
    <Flex w="100%" gap="20px" align="center" justify="space-between" >
        <Heading fontSize="1.6rem">{label || 'Title'}</Heading>
        <Flex gap="10px" align="center" justify="space-between" >
            {
                button_array && button_array.length > 0?
                button_array.map((eButton:any,index:number) => <span key={index}>{eButton}</span>
                ):''
            }
        </Flex>
    </Flex>
  )
}

export default TopDisplay